import { StationAssetId } from "@sdk-integration/contracts";

export class InstantTransmissionService {
  public active = false;
  public pathStationIds = [] as StationAssetId[];
}
